import {useTranslation} from '@/translations/i18n.tsx'
import introImage from '@/assets/introImage.png'
import {routes} from '@utilities/constants/routes'
import {Container} from '@components/ui/container'
import {AirbnbSSOWidget} from '@features/user/components/airbnb-sso-widget'
import {ButtonLink} from '@components/commons/button-link'
import {useMe} from '@features/user/queries/useMe'
import {isReviewerOnly} from '@features/user/utils'

export const LinkAirbnbAccount = () => {
    const {t} = useTranslation()
    const meQuery = useMe({throwOnError: true})
    return (
        <Container fullWidth fullHeight className="bg-white">
            <div className="flex flex-col items-center justify-center h-full w-full gap-4">
                <AirbnbSSOWidget
                    className="h-auto"
                    redirectUrl={routes.LINK_AIRBNB_ACCOUNT_CONFIRM.path}
                    title={t('link_airbnb_account:title')}
                    description={t('link_airbnb_account:description')}
                    image={introImage}
                />
                <ButtonLink
                    variant="tertiary"
                    shape="text"
                    to={
                        meQuery.data?.lastMarketsUpdatedAt || (meQuery.data && isReviewerOnly(meQuery.data))
                            ? routes.HOME.handle.fullPath
                            : routes.MARKETS_CONFIGURATION.handle.fullPath
                    }
                >
                    {t('link_airbnb_account:skip_for_now')}
                </ButtonLink>
            </div>
        </Container>
    )
}
